export default "__VITE_ASSET__d30240b9__"